import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/accounting/accounts/$code',
}).lazy(() => import('./accounts.$code.index.lazy').then((d) => d.Route))
